import { action } from 'typesafe-actions';
import {
  ConnectivityChipsTypes,
  ConnectivityChipRowInterface,
  ConnectivityChipDetailInterface,
} from './types';

// List Connectivity Chips
export const listConnectivityChipsRequest = (payload: { body?: object }) =>
  action(ConnectivityChipsTypes.LIST_CONNECTIVITY_CHIPS_REQUEST, payload);
export const listConnectivityChipsSuccess = (payload: {
  connectivityChips: ConnectivityChipRowInterface[];
  totalCount: number;
}) => action(ConnectivityChipsTypes.LIST_CONNECTIVITY_CHIPS_SUCCESS, payload);
export const listConnectivityChipsFailure = () =>
  action(ConnectivityChipsTypes.LIST_CONNECTIVITY_CHIPS_FAILURE);

// Get Connectivity Chip
export const getConnectivityChipRequest = (payload: { id: string }) =>
  action(ConnectivityChipsTypes.GET_CONNECTIVITY_CHIP_REQUEST, payload);
export const getConnectivityChipSuccess = (payload: {
  connectivityChip: ConnectivityChipDetailInterface;
}) => action(ConnectivityChipsTypes.GET_CONNECTIVITY_CHIP_SUCCESS, payload);
export const getConnectivityChipFailure = () =>
  action(ConnectivityChipsTypes.GET_CONNECTIVITY_CHIP_FAILURE);
